import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular';
import { MediaType } from '@models/imported/SagaBase';
import { ImagesSettingsService, SagaSettingsService } from '@services/settings';
import { ICustomFile } from '../../schema/interfaces/ICustomFile';

@Injectable()
export class ThumbnailService {
  constructor(private settingsService: SagaSettingsService, private imagesService: ImagesSettingsService, private platform: Platform) {}

  createThumbnail(customFile: ICustomFile): Promise<string> {
    switch (customFile.dataType) {
      case MediaType.Image:
        return this.createImageThumbnail(customFile);

      case MediaType.Video:
        return Promise.resolve(this.imagesService.get('VideoAttachments'));

      default:
        return Promise.resolve('');
    }
  }

  private createImageThumbnail(customFile: ICustomFile): Promise<string> {
    const newWidth: number = this.settingsService.getValue('SagaMobileWebClient.ThumbnailWidth');
    const newHeight: number = this.settingsService.getValue('SagaMobileWebClient.ThumbnailHeight');
    const quality: number = this.settingsService.getValue('SagaMobileWebClient.ThumbnailQuality');
    let imageSrc: string;
    if (!this.platform.is('cordova')) {
      imageSrc = customFile.url;
    } else {
      imageSrc = (window as any).Ionic.WebView.convertFileSrc(customFile.uri);
    }

    return new Promise((resolve, reject) => {
      const image = new Image();
      image.src = imageSrc;
      image.onload = () => {
        const element = document.createElement('canvas');
        element.width = newWidth;
        element.height = newHeight;
        const ctx = element.getContext('2d');
        ctx.drawImage(image, 0, 0, newWidth, newHeight);
        resolve(ctx.canvas.toDataURL('image/jpeg', quality));
      };
      image.onerror = error => reject(error);
    });
  }
}
